module.exports = __webpack_public_path__ + "static/4-db9b7d6686dd2d9a17b17e6a998c6f5d.jpeg";